export const LOCALISATION = {
  DEFAULT_LOCALE: 'en',
  EN: 'en',
  JA: 'ja',
};
